import { serverDateSort } from 'components/Tables/dateSorting';
import React, { CSSProperties, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import useTable from 'components/CCCTable/useTable';
import CCCTable from 'components/CCCTable/CCCTable';
import {
  MUTATION_ERROR_BULK_UPDATE,
  QUERY_AMOUNT_OF_ERRORS,
  QUERY_LIST_ERRORS,
} from 'queries/ErrorQueries';
import { useMutation } from '@apollo/client';
import { Modal } from 'antd';
import formatJson from 'utils/formatJson';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);

const ViewJson = ({ json }: { json?: string | null }) => {
  const formatted = formatJson(json, 3);
  if (!formatted) {
    return <span>Error parsing json</span>;
  }

  return <pre>{json ? formatted : null}</pre>;
};

const Index = () => {
  const { setTableRef, refetch } = useTable();
  const [detailed, setDetailed] = useState<any | boolean>(false);
  const [field, setField] = useState<string>('');

  const [deleteErrors] = useMutation(MUTATION_ERROR_BULK_UPDATE);

  const linkPopupStyle = useMemo(
    () => ({
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '320px',
    }),
    [],
  ) as CSSProperties;

  const columns = useMemo(
    () => [
      {
        title: 'Error Id',
        dataIndex: 'error_id',
        sorter: true,
        width: 100,
      },
      {
        title: 'Created On',
        dataIndex: 'created_on',
        render: (data: string) => dayjs(data).format('LLL'),
        ...serverDateSort(true),
        width: 160,
      },
      {
        title: 'User',
        dataIndex: ['user', 'first_name'],
        render: (_: string, record: any) => record.full_name,
        sorter: true,
        width: 160,
      },
      {
        title: 'Error Body',
        dataIndex: 'error_body',
        // sorter: true,
        width: 180,
        render: (data: string, record: any) => {
          return (
            <a
              href="#/"
              style={linkPopupStyle}
              onClick={(e: any) => {
                e.preventDefault();

                setField('error_body');
                setDetailed(record);
              }}
            >
              {data}
            </a>
          );
        },
      },
      {
        title: 'Related Data',
        dataIndex: 'related_data',
        // sorter: true,
        width: 180,
        render: (data: string, record: any) => {
          return (
            <a
              href="#/"
              style={linkPopupStyle}
              onClick={(e: any) => {
                e.preventDefault();

                setField('related_data');
                setDetailed(record);
              }}
            >
              {data}
            </a>
          );
        },
      },
    ],
    [linkPopupStyle],
  );

  const actions = [
    {
      label: 'Delete',
      danger: true,
      run: async (records: any[]) => {
        const primaryKeys = records.map((e: any) => ({
          error_id: e.error_id,
        }));

        await deleteErrors({
          variables: {
            primaryKeys,
            input: {
              deleted_on: new Date(),
            },
          },
          refetchQueries: [
            {
              query: QUERY_AMOUNT_OF_ERRORS,
            },
            {
              query: QUERY_LIST_ERRORS,
            },
          ],
        });

        refetch();
      },
    },
  ];

  return (
    <>
      <Modal open={!!detailed} onCancel={() => setDetailed(false)} width={900}>
        <ViewJson json={detailed[field]} />
      </Modal>

      <CCCTable
        ref={setTableRef}
        where={{ deleted_on: { isNull: true } }}
        query={QUERY_LIST_ERRORS}
        totalQuery={QUERY_AMOUNT_OF_ERRORS}
        queryKey="listErrorEntity"
        totalQueryKey="totalErrorEntity"
        rowKey="error_id"
        columns={columns}
        actions={actions}
      />
    </>
  );
};

export default Index;
